export const initialState = {
    loading: true,
    history: null
}